module.exports = __webpack_public_path__ + "img/13.6eabae47.webp";